var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSquare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill square",
    width: 27.5,
    height: 27.5,
    viewBox: "0 0 27.5 27.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9-171.944h3.056V-175A3.065,3.065,0,0,0,9-171.944Zm0,12.222h3.056v-3.056H9ZM15.111-147.5h3.056v-3.056H15.111ZM9-165.833h3.056v-3.056H9ZM24.278-175H21.222v3.056h3.056Zm9.167,0v3.056H36.5A3.065,3.065,0,0,0,33.444-175ZM12.056-147.5v-3.056H9A3.065,3.065,0,0,0,12.056-147.5ZM9-153.611h3.056v-3.056H9ZM18.167-175H15.111v3.056h3.056Zm3.056,27.5h3.056v-3.056H21.222Zm12.222-12.222H36.5v-3.056H33.444Zm0,12.222a3.065,3.065,0,0,0,3.056-3.056H33.444Zm0-18.333H36.5v-3.056H33.444Zm0,12.222H36.5v-3.056H33.444ZM27.333-147.5h3.056v-3.056H27.333Zm0-24.444h3.056V-175H27.333ZM15.111-153.611H30.389v-15.278H15.111Zm3.056-12.222h9.167v9.167H18.167Z",
    transform: "translate(-9 175)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/square.3bed1694.svg";
export { ForwardRef as ReactComponent };